/******************************************************************************
 * Created Date: Friday Feb 18 2022                                           *
 * Author: Patrick B.                                                         *
 * -----                                                                      *
 * Last Modified: Tue Mar 19 2022                                             *
 * Modified By: Patrick B.                                                    *
 * -----                                                                      *
 * File: /src/components/algorithms/quantification/InputTypeSelect.js         *
 * Copyright (c) 2022 Kuva                                                    *
 ******************************************************************************/

import {
  Select,
  FormControl,
  MenuItem,
  InputLabel,
  Typography
} from "@mui/material";
import PropTypes from "prop-types";

const InputTypeSelect = ({ inputType, setInputType }) => {
  const inputTypes = ["scanresult", "cloudscanresult", "cloudscanresult2"];

  const handleChange = event => {
    setInputType(event.target.value);
  };

  return (
    <FormControl
      variant="standard"
      style={{
        display: "flex"
      }}
    >
      <InputLabel
        style={{
          fontSize: 14,
          width: "100%"
        }}
        id="input-type-select-label"
      >
        <Typography>INPUT TYPE SELECT</Typography>
      </InputLabel>
      <Select
        variant="standard"
        id="input-type-select"
        value={inputType}
        label="INPUT TYPE"
        onChange={handleChange}
      >
        {inputTypes.map(inputType => {
          return (
            <MenuItem key={inputType} value={inputType}>
              {inputType}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  );
};

InputTypeSelect.propTypes = {
  inputType: PropTypes.string.isRequired,
  setInputType: PropTypes.func.isRequired
};

export default InputTypeSelect;
